import z from "zod";

const imageFileSchema = z
  .instanceof(File ,"الملف مطلوب")
  .refine((file) => file.size <= 12 * 1024 * 1024, "Max file size is 2MB")
  .refine(
    (file) =>
      [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
        "image/svg+xml",
      ].includes(file.type),
    "Invalid image type",
  );
export const curieorSchema = z.object({
  first_name: z.string().min(1, "الاسم الأول مطلوب").max(255),
  last_name: z.string().min(1, "الاسم الأخير مطلوب").max(255),
  email: z.string().email("الإيميل غير صالح").optional(),
  phone: z.string().min(1 ,"رقم الجوال مطلوب"),
  phone_code: z.string().min(1 ,"كود الدولة مطلوب"),
  license_number: z.string().min(1 ,"رقم الرخصة مطلوب"),
  birthday: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be YYYY-MM-DD"),
  commission_type: z.enum(["subscription","commission" ]),
  commission_amount: z.number("قيمه حساب التوصيل مطلوبة").int(),
  driving_license: imageFileSchema,
  avatar: imageFileSchema.optional(),
  avg_rate: z.number().optional(),
  store_id: z.number("المتجر مطلوب").int("المتجر مطلوب"),
  birthday: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date must be YYYY-MM-DD"),
  iban:z.string().optional(),
  zone_id:z.number("المنطقة مطلوبة").int("المنطقة مطلوبة"),
  latitude: z.number({
    message:"يرجي اختيار الموقع علي الخريطة",
    required_error: "يرجي اختيار الموقع علي الخريطة",
    invalid_type_error: "يرجي اختيار الموقع علي الخريطة",
  }),
  longitude: z.number({
      message:"يرجي اختيار الموقع علي الخريطة",
    required_error: "يرجي اختيار الموقع علي الخريطة",
    invalid_type_error: "يرجي اختيار الموقع علي الخريطة",
  }),
      front_image:  imageFileSchema,
    back_image: imageFileSchema,
    car_license:imageFileSchema,
    national_id:z.string().min(1,"رقم الهوية مطلوب")

})
